<template>
	<div class="dashboard">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col>
		 <!--<b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">{{$root.INFLUENCER_TEXT}} Dashboard</h5>
				</b-col>				
			</b-row>-->
			
			<b-container fluid class="mt-3">
					<b-row>
						<!-- <b-col class="px-2">
							<b-card img-src="../../assets/icons/crm.svg" img-alt="Card image" img-left class="info-box mb-3">
								<h6>Total Customers</h6>
								<b-card-text>
									0
								</b-card-text>
							</b-card>
						</b-col> 
						<b-col class="px-2">
							<b-link href="/agent/products">
								<b-card img-src="../../assets/icons/store.svg" img-alt="Card image" img-left class="info-box mb-3">
									<h6>Total Products</h6>
									<b-card-text>
										0 
									</b-card-text>
								</b-card>
							</b-link>
						</b-col>-->
									<b-col lg="4" md="4" sm="6" class="px-2">
										<b-card no-body class="overflow-hidden p-1">
											<b-row no-gutters>
											  <b-col cols="8">
												<b-card-body >
													<h6>Total Links</h6>
												  <b-card-text>
														<span v-if="$root.customer_info.user_id==6847">
															157
														</span>
														<span v-else>
														{{total_share}}
														</span>
												  </b-card-text>
												</b-card-body>
											  </b-col>
											   <b-col cols="4" class="text-center borderLeft">
												<span v-if="$root.customer_info.user_id==6847">
													<b-badge pill variant="success" v-b-tooltip.hover title="Active Link">108</b-badge>
													<br/>
													<b-badge pill variant="danger" v-b-tooltip.hover title="Expired Link" >49</b-badge>
													</span>
													<span v-else >
													<b-badge pill variant="success" v-b-tooltip.hover title="Active Link">{{total_active_liks}}</b-badge>
													<br/>
													<b-badge pill variant="danger" v-b-tooltip.hover title="Expired Link" >{{total_share-total_active_liks}}</b-badge>
													</span>
													
													
											  </b-col>
											</b-row>
											
											<footer class="card-footer p-0 mt-1">
												<b-row no-gutters>
													<b-col  class="text-center ">	
														<b-link href="/agent/share-links" style="font-size:12px;">
														<b-iconstack style="font-size:12px;">
														  <b-icon stacked icon="square"></b-icon>
														  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
														  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
														  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
														  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
														  <b-icon stacked icon="dot" shift-h="3"></b-icon>
														  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
														</b-iconstack>
														</b-link>
													</b-col>
												   <b-col  class="text-center">
														
														<b-link block v-b-toggle.totalSeller variant="info"> <i class="fa fa-caret-down" aria-hidden="true"></i> </b-link> 										
												  </b-col>
												</b-row>
													<b-collapse id="totalSeller"  accordion="my-accordion" role="tabpanel">
												<b-card-body>
												   <b-list-group v-if="$root.customer_info.user_id==6847">
													  <b-list-group-item>Total Views : <div class="textCount"> 1026</div> </b-list-group-item>
													  <b-list-group-item>Total Shared : <div class="textCount" >1202  </div></b-list-group-item>
													  <b-list-group-item>Not Shared :<div class="textCount" > 5</div></b-list-group-item> 
													</b-list-group> 
													<b-list-group v-else>
													  <b-list-group-item>Total Views : <div class="textCount"> {{total_views}}</div> </b-list-group-item>
													  <b-list-group-item>Total Shared : <div class="textCount" >{{total_share_count}}  </div></b-list-group-item>
													  <b-list-group-item>Not Shared :<div class="textCount" > {{total_share -total_share_count}} </div></b-list-group-item> 
													</b-list-group>
												</b-card-body>
										  </b-collapse>	
											</footer>
										</b-card>
										
								</b-col>

						<!-- <b-col class="px-2" lg="4">
							<b-link href="/agent/share-links">
								<b-card img-src="../../assets/icons/share.svg" img-alt="Share Links" img-left class="info-box mb-3">
									<h6>Active Links</h6>
									<b-card-text>
										
										<span v-if="$root.customer_info.user_id==83">
											157
										</span>
										<span v-else>
										{{total_share}}
										</span>
									</b-card-text>
								</b-card>
							</b-link>
						</b-col> -->
						
								<b-col lg="4" md="4" sm="6" class="px-2" >
									<b-card no-body class="overflow-hidden p-1">
										<b-row no-gutters>
										  <b-col cols="8">
											<b-card-body >
												<h6>Active Orders</h6>
											  <b-card-text>
												<span v-if="$root.customer_info.user_id==6847">
															2
												</span>
												<span v-else>
												{{total_orders}}
												</span>
										</b-card-text>
											</b-card-body>
										  </b-col>
										  
										   <b-col cols="4" class="text-center borderLeft">
													<span v-if="$root.customer_info.user_id==6847">
													<b-badge pill variant="success" v-b-tooltip.hover title="Fulfilled"  >254</b-badge>
														<br/>
													<b-badge pill variant="danger" v-b-tooltip.hover title="Cancelled">4</b-badge>
													</span>
													<span v-else>
													<b-badge pill variant="success" v-b-tooltip.hover title="Fulfilled"  >{{activeOrdersList.completed[0]}}</b-badge>
														<br/>
													<b-badge pill variant="danger" v-b-tooltip.hover title="Cancelled">{{activeOrdersList.cancelled[0]|0}}</b-badge>
													</span>
													
										  </b-col>
										</b-row>
										<footer class="card-footer p-0 mt-1">
											<b-row no-gutters>
												<b-col  class="text-center ">	
													<b-link href="/agent/commissions" style="font-size:12px;">
													<b-iconstack style="font-size:12px;">
													  <b-icon stacked icon="square"></b-icon>
													  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
													  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
													  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
													  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
													  <b-icon stacked icon="dot" shift-h="3"></b-icon>
													  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
													</b-iconstack>
													</b-link>
												</b-col>
											   <b-col  class="text-center">
													
													<b-link block v-b-toggle.totalAget variant="info"> <i class="fa fa-caret-down" aria-hidden="true"></i> </b-link> 										
											  </b-col>
											</b-row>
												<b-collapse id="totalAget"  accordion="my-accordion" role="tabpanel">
												<b-card-body>
												   <b-list-group v-if="$root.customer_info.user_id==6847">
													  <b-list-group-item>Total Orders : <div class="textCount" > 258 </div> </b-list-group-item>
													  <b-list-group-item>Total Cancelled : <div class="textCount" > 4 </div></b-list-group-item>
													 
													  <b-list-group-item>Total Fulfilled :<div class="textCount" > 252 </div></b-list-group-item>
													</b-list-group>
													<b-list-group v-else >
													  <b-list-group-item>Total Orders : <div class="textCount" > {{activeOrdersList.sales[0]}} </div> </b-list-group-item>
													  <b-list-group-item>Total Cancelled : <div class="textCount" > {{activeOrdersList.cancelled[0]}} </div></b-list-group-item>
													 
													  <b-list-group-item>Total Fulfilled :<div class="textCount" > {{activeOrdersList.completed[0]}} </div></b-list-group-item>
													</b-list-group>
												</b-card-body>
											</b-collapse>	
										</footer>
									</b-card>

										
										
									
								</b-col>

						
						<!-- <b-col class="px-2" lg="4">
							<b-card img-src="../../assets/icons/orders.svg" img-alt="Card image" img-left class="info-box mb-3">
								<h6>Active Orders</h6>
								<b-card-text>
								<span v-if="$root.customer_info.user_id==83">
											556
								</span>
								<span v-else>
								{{total_orders}}
								</span>
								
								
								</b-card-text>
							</b-card>
						</b-col> -->
									<b-col lg="4" md="4" sm="6" class="px-2">
										<b-card no-body class="overflow-hidden p-1">
											<b-row no-gutters>
											  <b-col cols="8" >
												<b-card-body >
													<h6 class="py-2 pt-3" >Commission</h6>
												  <!-- <b-card-text>
													{{$root.currency()+$root.tofixed(total_sales, 2)}}

												  </b-card-text>-->
												</b-card-body>
											  </b-col>
											   <b-col cols="4" class="text-center borderLeft ">
														<div class="py-2 pt-3"><span v-if="$root.customer_info.user_id==6847">
									{{$root.currency()+$root.tofixed('18100',2)}}
									</span>
									<span v-else>
									{{$root.currency()+$root.tofixed(total_commission,2)}}
									</span></div>
														
													
											  </b-col>
											</b-row>
											<footer class="card-footer p-0 mt-1">
												<b-row no-gutters>
													<b-col  class="text-center ">	
														<b-link href="/agent/commissions" style="font-size:12px;">
														<b-iconstack style="font-size:12px;">
														  <b-icon stacked icon="square"></b-icon>
														  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
														  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
														  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
														  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
														  <b-icon stacked icon="dot" shift-h="3"></b-icon>
														  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
														</b-iconstack>
														</b-link>
													</b-col>
												   <b-col  class="text-center">
														
														<b-link block v-b-toggle.totalSales variant="info"> <i class="fa fa-caret-down" aria-hidden="true"></i> </b-link> 										
												  </b-col>
												</b-row>
													<b-collapse id="totalSales"  accordion="my-totalSales" role="tabpanel">
													<b-card-body>
													   <!-- <b-list-group >
														  <b-list-group-item>Total Earn : <div class="textCount" > ---- </div> </b-list-group-item>
														 
														</b-list-group> -->
													</b-card-body>
												</b-collapse>	
											</footer>
										</b-card>

											
											
										
									</b-col>

						<!-- <b-col class="px-2" lg="4">
							<b-card img-src="../../assets/icons/commission.svg" img-alt="Card image" img-left class="info-box mb-3">
								<h6>Commission</h6>
								<b-card-text>
								<span v-if="$root.customer_info.user_id==83">
								{{$root.currency()+$root.tofixed('22721',2)}}
								</span>
								<span v-else>
								{{$root.currency()+$root.tofixed(total_commission,2)}}
								</span>
								
								
								</b-card-text>
							</b-card>
						</b-col> -->
					</b-row>
				<b-row >
					<b-col class="px-2" lg="6" sm="12">
						<b-card class="p-0">
							<coupon-popup></coupon-popup>
						</b-card>
						<b-card class="p-0">
						<referafriend-popup></referafriend-popup>
						
							
						</b-card>
						<b-card class="p-0">
							<div class="card-header border-0">
								<b-row  class=" align-items-center">
									<b-col cols="9"><h6 class="mb-0">Commission Summary </h6></b-col> 
									<!--<b-col cols="6" class="p-0">
									 <b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.daily">Today</b-button>
									<b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.weekly">This Week</b-button>
									<b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.monthly">This Month</b-button>
									<b-button class="rounded-pill fontSize9" size="sm" @click="summary_selected = summary.all">All</b-button> 
									</b-col>-->
									
									<b-col cols="3" class="text-right"><b-link block v-b-toggle.salseCSummer variant="info"> <i class="fa fa-caret-down"></i> </b-link></b-col>
									</b-row>
							</div>
						
							
							<b-collapse id="salseCSummer" visible accordion="my-salseCSummer" role="tabpanel"> 
							
								<div class="el-table table-responsive table el-table--fit el-table--scrollable-Y el-table--enable-row-hover el-table--enable-row-transition b-table-sticky-header">
									<div class="hidden-columns"><div></div><div></div><div></div></div>
									<div class="el-table__header-wrapper">
										<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%;">
										<colgroup>
											<col name="el-table_2_column_5" width="50%">
											<col name="el-table_2_column_6" width="30%">
											<col name="el-table_2_column_7" width="20%">
											
											<col name="gutter" width="0"></colgroup>
												<thead class="has-gutter">
													<tr class="thead-light">
													<th colspan="1" rowspan="1" class="el-table_2_column_5 is-leaf"><div class="cell">Order ID</div></th>
													<th colspan="1" rowspan="1" class="el-table_2_column_6 is-leaf"><div class="cell">Date</div></th>
													<th colspan="1" rowspan="1" class="el-table_2_column_7 is-leaf"><div class="cell">Commission</div></th>
													<!-- <th colspan="1" rowspan="1" class="el-table_2_column_8 is-leaf"><div class="cell">Price</div></th> -->
													</tr>
												</thead>
											</table>
										</div>
										<div class="el-table__body-wrapper is-scrolling-right">
										<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
										<colgroup>
											<col name="el-table_2_column_5" width="50%">
											<col name="el-table_2_column_6" width="30%">
											<col name="el-table_2_column_7" width="20%">
											
										</colgroup> 
										<tbody>
											<tr class="el-table__row"  v-for="item in commision_summary" :key="item.id">
											<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">{{item.uuid}}</div></div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">{{$moment(item.created_at).format('DD-MM-YYYY')}}</div></div></td>
											<td rowspan="1" colspan="1" class="el-table_2_column_7  "><div class="cell"><!--{{$root.currency()+$root.tofixed(item.commission,2)}} --> {{calculatecommision(item)}}</div></td>
											
										</tr>
											
										<!----></tbody></table><!----><!----></div><!----><!----><!----><!---->
										<div class="el-table__column-resize-proxy" style="display: none;"></div>
										
										</div>
							</b-collapse>
						</b-card>

						<!-- <b-card header="Monthly Commision">
							<line-chart ref="commisionchart" :height="200"/>
						</b-card> -->
					</b-col>
					<b-col class="px-2" lg="6" sm="12">
						<b-card class="p-0">
							<div class="card-header border-0">
								<b-row  class=" align-items-center">
									<b-col cols="12" lg="5" md="12" sm="12"><h6 class="mb-0">Orders Summary </h6></b-col> 
									<b-col cols="10" lg="6" md="10" sm="10" class="p-0"><b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.daily">Today</b-button>
									<b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.weekly">This Week</b-button>
									<b-button class="rounded-pill mr-2 fontSize9" size="sm" @click="summary_selected = summary.monthly">This Month</b-button>
									<b-button class="rounded-pill fontSize9" size="sm" @click="summary_selected = summary.all">All</b-button></b-col>
									
									<b-col cols="2" lg="1" md="2" sm="2" class="text-right"><b-link block v-b-toggle.salseSummer variant="info"> <i class="fa fa-caret-down"></i> </b-link></b-col>
									</b-row>
							</div>
								
								<b-collapse id="salseSummer" visible accordion="my-salseSummer" role="tabpanel">
								
								<div class="el-table table-responsive table el-table--fit el-table--scrollable-Y el-table--enable-row-hover el-table--enable-row-transition b-table-sticky-header">
								<div class="hidden-columns"><div></div><div></div><div></div></div>
									<div class="el-table__body-wrapper is-scrolling-right">
										<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
											<colgroup>
												<col name="el-table_2_column_5" width="50%">
													<col name="el-table_2_column_6" width="30%"><col name="el-table_2_column_7" width="20%">
											</colgroup> 
												<tbody v-if="$root.customer_info.user_id==6847">
													<tr class="el-table__row" >
														<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Sales</div></div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">258</div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(180600, 2)}}</td>
													</tr>
													
													<tr class="el-table__row" >
														<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Orders</div></div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">258</div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(180600, 2)}}</td>
													</tr>
													
													<tr class="el-table__row" >
														<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Cancelled</div></div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">4</div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed('2800',2)}}</td>
													</tr>
													<tr class="el-table__row" >
														<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Fulfilled</div></div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">254</div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed('177800',2)}}</td>
													</tr>
													
														
												</tbody>
												<tbody v-else>
													<tr class="el-table__row" >
														<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Sales</div></div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.sales[0]}}</div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.sales[1], 2)}}</td>
													</tr>
													
													<tr class="el-table__row" >
														<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Orders</div></div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.orders[0]}}</div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.orders[1] ? summary_selected.orders[1]: 0, 2)}}</td>
													</tr>
													
													<tr class="el-table__row" >
														<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Cancelled</div></div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.cancelled[0]}}</div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.cancelled[1],2)}}</td>
													</tr>
													<tr class="el-table__row" >
														<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">Total Fulfilled</div></div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell">{{summary_selected.completed[0]}}</div></td>
														<td rowspan="1" colspan="1" class="el-table_2_column_7">{{$root.currency()+$root.tofixed(summary_selected.completed[1],2)}}</td>
													</tr>
													
														
												</tbody>
										</table>
								</div>
								<div class="el-table__column-resize-proxy" style="display: none;"></div>
												
								</div>
								
								
								</b-collapse>
							</b-card>
							
							
							<div class="card"><!---->
							<div class="card-header border-0"><div class="row align-items-center"><div class="col"><h6 class="mb-0">Last Orders</h6></div><div class="text-right col">
										<b-link href="/agent/commissions" style="font-size:12px;">
											<b-iconstack style="font-size:12px;">
											  <b-icon stacked icon="square"></b-icon>
											  <b-icon stacked icon="dot" shift-h="-3" shift-v="4"></b-icon>
											  <b-icon stacked icon="dot" shift-h="-3"></b-icon>
											  <b-icon stacked icon="dot" shift-h="-3" shift-v="-4"></b-icon>
											  <b-icon stacked icon="dot" shift-h="3" shift-v="4"></b-icon>
											  <b-icon stacked icon="dot" shift-h="3"></b-icon>
											  <b-icon stacked icon="dot" shift-h="3" shift-v="-4"></b-icon>
											</b-iconstack>
									</b-link><b-link block v-b-toggle.latestOrder variant="info"> <i class="fa fa-caret-down ml-2"></i> </b-link></div></div></div>
							<b-collapse id="latestOrder" visible accordion="my-latestOrder" role="tabpanel">
								<div class="card-body p-0">
								<!----><!---->
										<div class="el-table table-responsive table el-table--fit el-table--scrollable-Y el-table--enable-row-hover el-table--enable-row-transition b-table-sticky-header">
											<div class="hidden-columns"><div></div><div></div><div></div></div>
											<div class="el-table__header-wrapper">
												<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%;">
												<colgroup>
													<col name="el-table_2_column_5" width="30%">
													<col name="el-table_2_column_6" width="35%">
													<col name="el-table_2_column_6" width="15%">
													<col name="el-table_2_column_7" width="20%">
													<col name="gutter" width="0"></colgroup>
														<thead class="has-gutter">
															<tr class="thead-light">
															<th colspan="1" rowspan="1" class="el-table_2_column_5 is-leaf"><div class="cell">SKU</div></th>
															<th colspan="1" rowspan="1" class="el-table_2_column_6 is-leaf"><div class="cell">Date</div></th>
															<th colspan="1" rowspan="1" class="el-table_2_column_7 is-leaf"><div class="cell">Qty</div></th>
															<th colspan="1" rowspan="1" class="el-table_2_column_8 is-leaf"><div class="cell">Price</div></th>
															</tr>
														</thead>
													</table>
												</div>
												<div class="el-table__body-wrapper is-scrolling-right">
												<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
												<colgroup>
													<col name="el-table_2_column_5" width="30%">
													<col name="el-table_2_column_6" width="35%">
													<col name="el-table_2_column_7" width="15%">
													<col name="el-table_2_column_8" width="20%">
												</colgroup> 
												<tbody>
													<tr class="el-table__row"  v-for="item in last_orders" :key="item.id">
													<td rowspan="1" colspan="1" class="el-table_2_column_5  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">{{item.sku}}</div></div></td>
													<td rowspan="1" colspan="1" class="el-table_2_column_6  "><div class="cell"><div class="font-weight-600" style="text-transform: capitalize;">{{$moment(item.created_at).format('DD-MM-YYYY')}}</div></div></td>
													<td rowspan="1" colspan="1" class="el-table_2_column_7  "><div class="cell">{{item.total_items}}</div></td>
													<td rowspan="1" colspan="1" class="el-table_2_column_8"> {{$root.currency()+$root.tofixed(item.price,2)}}</td>
												</tr>
													
												<!----></tbody></table><!----><!----></div><!----><!----><!----><!---->
												<div class="el-table__column-resize-proxy" style="display: none;"></div>
												
												</div>
											
											</div>
									</b-collapse>	
										
								</div>

							

						<!--<b-card header="Monthly Orders">
							<bar-chart ref="orderschart" :height="200"/>
						</b-card> -->
					</b-col>
				</b-row>
			</b-container>
			
		<set-password></set-password>
		<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		
		<!-- {{monthly_commision_month}} -->
		
	
	</div>
</template>
<script>
//import Header from "@/components/agent/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/agent/nevleft.vue";
import Setpassword from "@/components/setpassword.vue";
import Referafriendpopup from "@/components/referafriend-popup.vue";
import Couponpopup from "@/components/coupon-popup.vue";
//import { Line, Bar } from 'vue-chartjs';
export default {
	name: 'AgentDashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
		"top-header": Header,
		//"line-chart": Line,
		//"bar-chart": Bar,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"set-password": Setpassword,
		"referafriend-popup": Referafriendpopup,
		"coupon-popup": Couponpopup,
		
	},
	mounted(){
		this.initload();
		/* *this.$refs.commisionchart.renderChart({
			labels: this.monthly_commision_month, 
			/*['January', 'February', 'March', 'April', 'May', 'June','Jully','Augest'],*/
			/*datasets: [
				{
					label: ' Commision',
					backgroundColor: '#99d6ff',
					data: this.monthly_commision_amount
				}
			]},{
			responsive: true
		});
		this.$refs.orderschart.renderChart({
			labels: this.orderschartMonth, /*['January', 'February', 'March', 'April', 'May', 'June']*/
			/*datasets: [
				{
					label: 'Total',
					backgroundColor: '#ffcc00',
					data: this.monthly_grap_order_total,
				},
				{
					label: ' Fulfilled',
					backgroundColor: '#00cc66',
					data: this.monthly_grap_order_completed,
				},
				{
					label: ' Canceled',
					backgroundColor: '#ff3300',
					data: this.monthly_grap_order_cancelled,
				},
				{
					label: ' Refunded',
					backgroundColor: '#f20ea2',
					data: this.monthly_grap_order_refunded,
				}
			]},{
			responsive: true
		});
		*/
		
		var chagePassword = this.$route.params.activenew;
			if(chagePassword=='setpassword'){
				console.log('chagePassword:setpassword-'+chagePassword);
				this.$root.$emit('bv::show::modal', 'setpassword');
			}
		//this.$root.$emit('bv::show::modal', 'diwalipopup');
		//console.log('postEmailid'+this.postEmailid);
	},
	data() {
		return{
			total_orders:0,
			total_users: 0,
			total_products: 0,
			total_share: 0,
			total_share_count: 0,
			total_views: 0,
			total_active_liks:0,
			total_commission: 0,
			monthly_commision:[],
			monthly_commision_month:[],
			monthly_commision_amount:[],
			monthly_grap_order_total:[],
			monthly_grap_order_completed:[],
			monthly_grap_order_cancelled:[],
			monthly_grap_order_refunded:[],
			orderschartMonth:['January', 'February', 'March', 'April', 'May', 'June','July','August','September','October','November','December'],
			orderschartTotal:[],
			//url: this.$root.WEBAPI+'agentapi/dashboard',
			url: this.$root.WEBAPI+'agentapi/dashboardnew',
			chartData: {
				labels: [this.getRandomInt(), this.getRandomInt()],
				datasets: [
					{
					label: 'Data One',
					backgroundColor: '#f87979',
					data: [this.getRandomInt(), this.getRandomInt()]
					}, {
					label: 'Data One',
					backgroundColor: '#f87979',
					data: [this.getRandomInt(), this.getRandomInt()]
					}
				]
			},
			chartOptions: '',
			summary_selected: {
				sales: [0,0],
				orders: [0,0],
				cancelled: [0,0],
				completed: [0,0]
			},
			summary: {},
			activeOrdersList:{
				sales: [0,0],
				orders: [0,0],
				cancelled: [0,0],
				completed: [0,0]
			},
			last_orders: [],
			commision_summary:[],
			
		};
	},
	methods: {
		
		getRandomInt () {
			return Math.floor(Math.random() * (50 - 5 + 1)) + 5
		},
		initload(){
			var self = this;
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.total_orders 		= response.data.result.total_orders;
					self.total_products 	= response.data.result.total_products;
					self.total_share 		= response.data.result.total_share;
					self.total_share_count 	= response.data.result.total_share_count;
					self.total_views 		= response.data.result.total_views;
					self.total_active_liks 	= response.data.result.total_active_liks;					
					self.total_commission 	= response.data.result.total_commission;
					self.monthly_commision 	= response.data.result.monthly_commision;
					var monthly_grap_order 	= response.data.result.monthly_grap_order;
					var monthly_grap_completed 	= response.data.result.monthly_grap_order_completed;
					var monthly_grap_cancelled 	= response.data.result.monthly_grap_order_cancelled;
					var monthly_grap_refunded 	= response.data.result.monthly_grap_order_refunded;
					self.summary 				= response.data.result.summary;
					self.summary_selected 		= self.summary.daily;
					self.activeOrdersList 		= self.summary.all;
					
					
					
					 //var unloginRow=0;
					/* self.monthly_commision.forEach(item => {						
						self.monthly_commision_month.push(item.month);
						self.monthly_commision_amount.push(item.total_commission_inmonth);
					}); */
					//self.totalUnloginRow = unloginRow; 
					
					
					monthly_grap_order.forEach(item => {
						self.monthly_grap_order_total.push(item.totalOrder);
					});
					monthly_grap_completed.forEach(item => {
						self.monthly_grap_order_completed.push(item.totalOrder);
					});
					monthly_grap_cancelled.forEach(item => {
						self.monthly_grap_order_cancelled.push(item.totalOrder);
					});
					monthly_grap_refunded.forEach(item => {
						self.monthly_grap_order_refunded.push(item.totalOrder);
					});
					
					
					
					var last_orders = response.data.result.lastorders;	
					
					
					last_orders.forEach((item) => {
						var order_items =JSON.parse(item.order_items);
						
						var oI ={'price':item.price,
							'total_items':item.total_items,
							'created_at':item.created_at,
							'product_name':order_items[0].title,
							'sku':order_items[0].sku
							};
						
						self.last_orders.push(oI);

					});
					
					
					self.commision_summary = response.data.result.commision_summary;
					
						var totalCommission=0;
					 response.data.result.commision_summary.forEach((item) => {
						var order_items =JSON.parse(item.order_items);
						totalCommission+= Number(item.price*order_items[0].commission)/100;
						

					});
					 self.total_commission = totalCommission;
					
					//self.totalUnloginRow = unloginRow;
					
					/* total_share

					self.dashboard_data = response.data.result;
					self.records = response.data.result.records;
					self.zones = response.data.result.zones;*/

				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		calculatecommision(items) {
			//console.log(items);
				var itemL = JSON.parse(items.order_items);
				  var comis =  Number((items.price*itemL[0].commission)/100);
				 return this.$root.currency()+this.$root.tofixed((comis),2);
				//console.log(arrFiltered);
		}
	}
}
</script>
<style scoped lang="scss">
.dashboard{
	.borderLeft{
		border-left: 1px solid #c6c6c682;
	}
	.list-group{
		&-item{
			padding:5px;
			font-size:12px;
			.textCount{float: right;
						width: 50%;}
		}
	}
	.fontSize9{font-size: 9px;}
}
</style>